import { render, staticRenderFns } from "./Free.vue?vue&type=template&id=2f0a4fac&scoped=true&"
import script from "./Free.vue?vue&type=script&lang=js&"
export * from "./Free.vue?vue&type=script&lang=js&"
import style0 from "./Free.vue?vue&type=style&index=0&id=2f0a4fac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f0a4fac",
  null
  
)

export default component.exports